import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';
import { HeroComponent } from '../hero/hero.component';
import { HomeCarouselComponent } from '../home-carousel/home-carousel.component';
import { HomeFeaturedComponent } from '../home-featured/home-featured.component';
import { BlogListComponent } from '../blog-list/blog-list.component';

@Component({
    selector: 'tea-shop-fe-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [HeroComponent, HomeCarouselComponent, HomeFeaturedComponent, BlogListComponent]
})
export class HomeComponent {
  private metaDataService = inject(MetaDataService);

  constructor() {
    this.metaDataService.updateMetadata({
      title: 'Sencha Tea - True Teas for Masters',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
  }
}
